import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../Sync.styles';
import theme from '../../../../styles/theme';
import type { MuscleSyncItemDto } from '../../../../services/redux/api/syncApi';

interface SyncMuscleJsonViewProps {
  item: MuscleSyncItemDto | null;
}

export function SyncMuscleJsonView({ item }: SyncMuscleJsonViewProps) {
  const { t } = useTranslation();
  const { classes } = useStyles(theme);

  return (
    <div className={classes.jsonColumn}>
      <div className={classes.panelTitle}>
        {t('adminDashboard.sync.jsonView')}
      </div>
      <div className={classes.jsonContent}>
        {item
          ? JSON.stringify(item, null, 2)
          : t('adminDashboard.sync.selectItem')}
      </div>
    </div>
  );
}
